/* ================================================================
   LO&CO — Shopify Theme JavaScript
   Navigation, Scroll Animations, Product Variants, Cart, Testimonials
   ================================================================ */

(function () {
  'use strict';

  // ========== NAVIGATION ==========
  const nav = document.querySelector('.nav');
  const burger = document.getElementById('nav-burger');
  const mobileMenu = document.getElementById('nav-mobile');
  let lastScroll = 0;
  const isInnerPage = nav && nav.classList.contains('nav--scrolled');

  if (nav) {
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;

      // Ne jamais cacher le nav si le menu mobile est ouvert
      if (mobileMenu && mobileMenu.classList.contains('open')) {
        lastScroll = scrollY;
        return;
      }

      if (!isInnerPage) {
        nav.classList.toggle('nav--scrolled', scrollY > 80);

        if (scrollY > 300) {
          if (scrollY > lastScroll && scrollY - lastScroll > 5) {
            nav.classList.add('nav--hidden');
          } else if (lastScroll - scrollY > 5) {
            nav.classList.remove('nav--hidden');
          }
        } else {
          nav.classList.remove('nav--hidden');
        }
      }

      lastScroll = scrollY;
    }, { passive: true });
  }

  // Mobile menu
  if (burger && mobileMenu) {
    burger.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.contains('open');
      burger.classList.toggle('active');
      mobileMenu.classList.toggle('open');
      nav.classList.toggle('nav--menu-open', !isOpen);

      if (!isOpen) {
        // Ouverture : rendre le nav visible + bloquer le scroll (iOS-safe)
        nav.classList.remove('nav--hidden');
        document.documentElement.style.setProperty('--scroll-y', window.scrollY + 'px');
        document.body.classList.add('menu-open');
      } else {
        // Fermeture
        document.body.classList.remove('menu-open');
      }
    });

    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        burger.classList.remove('active');
        mobileMenu.classList.remove('open');
        nav.classList.remove('nav--menu-open');
        document.body.classList.remove('menu-open');
      });
    });
  }

  // Desktop dropdown: click on parent link opens dropdown, doesn't navigate
  document.querySelectorAll('.nav-item--dropdown > .nav-link').forEach(link => {
    link.addEventListener('click', e => e.preventDefault());
  });

  // Mobile menu: apply stagger delays dynamically based on item index
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach((el, i) => {
      el.style.transitionDelay = `${0.05 + i * 0.05}s`;
    });
  }

  // ========== SCROLL ANIMATIONS ==========
  function observeRevealElements(container) {
    const elements = (container || document).querySelectorAll('.reveal:not(.visible)');
    if (elements.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -60px 0px'
    });

    elements.forEach(el => observer.observe(el));
  }

  observeRevealElements();

  // ========== PARALLAX ==========
  const parallaxEl = document.querySelector('.hero-parallax');
  if (parallaxEl) {
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      if (scrollY < window.innerHeight) {
        parallaxEl.style.transform = `translateY(${scrollY * 0.3}px)`;
      }
    }, { passive: true });
  }

  // ========== TESTIMONIALS DRAG-TO-SCROLL ==========
  const testimonialsTrack = document.querySelector('.testimonials-track');
  if (testimonialsTrack) {
    let isDragging = false;
    let startX = 0;
    let scrollStart = 0;
    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let momentumId = null;

    function stopMomentum() {
      if (momentumId) {
        cancelAnimationFrame(momentumId);
        momentumId = null;
      }
    }

    function applyMomentum() {
      if (Math.abs(velocity) < 0.5) { velocity = 0; return; }
      testimonialsTrack.scrollLeft += velocity;
      velocity *= 0.92;
      momentumId = requestAnimationFrame(applyMomentum);
    }

    testimonialsTrack.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX;
      scrollStart = testimonialsTrack.scrollLeft;
      lastX = e.pageX;
      lastTime = Date.now();
      velocity = 0;
      stopMomentum();
      testimonialsTrack.style.cursor = 'grabbing';
      testimonialsTrack.style.scrollSnapType = 'none';
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const dx = e.pageX - startX;
      testimonialsTrack.scrollLeft = scrollStart - dx;

      const now = Date.now();
      const dt = now - lastTime;
      if (dt > 0) {
        velocity = (lastX - e.pageX) / dt * 16;
        lastX = e.pageX;
        lastTime = now;
      }
    });

    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      testimonialsTrack.style.cursor = '';
      testimonialsTrack.style.scrollSnapType = '';
      if (Math.abs(velocity) > 1) applyMomentum();
    });

    testimonialsTrack.addEventListener('click', (e) => {
      if (Math.abs(velocity) > 2) e.preventDefault();
    });

    testimonialsTrack.style.cursor = 'grab';
  }

  // ========== PRODUCT PAGE — GALLERY ==========
  const mainImage = document.getElementById('main-product-image');
  const thumbs = document.querySelectorAll('.product-gallery-thumb');

  if (mainImage && thumbs.length > 0) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const newSrc = thumb.dataset.imageUrl;
        if (newSrc) mainImage.src = newSrc;
      });
    });
  }

  // ========== PRODUCT PAGE — VARIANT SELECTOR ==========
  const productJSON = document.getElementById('product-json');
  if (productJSON) {
    const product = JSON.parse(productJSON.textContent);
    const variantIdInput = document.getElementById('variant-id');
    const addToCartBtn = document.querySelector('.btn-add-to-cart');
    const priceEl = document.querySelector('.product-info-price');
    const stockEl = document.getElementById('size-stock');

    // Current selected options
    let selectedOptions = {};
    product.options.forEach((opt, i) => {
      selectedOptions[i] = product.variants[0].options[i];
    });

    // Handle option clicks (size buttons + color swatches)
    document.querySelectorAll('.size-btn:not(.out-of-stock), .color-swatch').forEach(btn => {
      btn.addEventListener('click', () => {
        const optionIndex = parseInt(btn.dataset.optionIndex);
        const value = btn.dataset.value;

        // Update UI
        btn.parentElement.querySelectorAll('.size-btn, .color-swatch').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // Update selected options
        selectedOptions[optionIndex] = value;

        // Find matching variant
        const matchingVariant = product.variants.find(v => {
          return Object.keys(selectedOptions).every(i => v.options[parseInt(i)] === selectedOptions[i]);
        });

        if (matchingVariant) {
          variantIdInput.value = matchingVariant.id;

          // Update price
          if (priceEl) {
            priceEl.textContent = (matchingVariant.price / 100).toFixed(2).replace('.', ',') + ' €';
          }

          // Update stock display
          if (stockEl) {
            if (matchingVariant.inventory_quantity <= 3 && matchingVariant.inventory_quantity > 0) {
              stockEl.textContent = `Plus que ${matchingVariant.inventory_quantity} en stock !`;
              stockEl.style.display = '';
            } else {
              stockEl.style.display = 'none';
            }
          }

          // Update add to cart button
          if (addToCartBtn) {
            if (matchingVariant.available) {
              addToCartBtn.disabled = false;
              addToCartBtn.querySelector('span') && (addToCartBtn.querySelector('span').textContent = 'Ajouter au panier');
            } else {
              addToCartBtn.disabled = true;
              addToCartBtn.querySelector('span') && (addToCartBtn.querySelector('span').textContent = 'Rupture de stock');
            }
          }

          // Update main image if variant has a featured image
          if (matchingVariant.featured_image && mainImage) {
            const newSrc = matchingVariant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/, '_900x$1$2');
            mainImage.src = newSrc;
            // Sync active thumbnail if it matches
            thumbs.forEach(thumb => {
              thumb.classList.remove('active');
              if (thumb.dataset.imageUrl && thumb.dataset.imageUrl.includes(matchingVariant.featured_image.src.split('?')[0].split('/').pop().split('.')[0])) {
                thumb.classList.add('active');
              }
            });
          }
        }
      });
    });
  }

  // ========== CART PAGE — QUANTITY BUTTONS ==========
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.qty-input');
      if (!input) return;

      let qty = parseInt(input.value) || 1;
      if (btn.dataset.action === 'increase') {
        qty++;
      } else if (btn.dataset.action === 'decrease' && qty > 0) {
        qty--;
      }
      input.value = qty;

      // Submit cart update
      const line = btn.dataset.line;
      if (line) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity: qty })
        }).then(() => window.location.reload());
      }
    });
  });

  // ========== COLLECTION PAGE — SEARCH FILTER ==========
  const searchInput = document.getElementById('collection-search');
  if (searchInput) {
    let searchTimeout;
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        const query = searchInput.value.toLowerCase().trim();
        const cards = document.querySelectorAll('.product-card');
        let visibleCount = 0;

        cards.forEach(card => {
          const name = card.querySelector('.product-card-name');
          const text = name ? name.textContent.toLowerCase() : '';
          const match = !query || text.includes(query);
          card.style.display = match ? '' : 'none';
          if (match) visibleCount++;
        });

        const countEl = document.querySelector('.results-count span');
        if (countEl) countEl.textContent = visibleCount;
      }, 200);
    });
  }

  // ========== COLLECTION PAGE — SORT ==========
  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    // Set current value from URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) sortSelect.value = currentSort;

    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ========== CART COUNT — UPDATE AFTER AJAX ==========
  function updateCartCount(count) {
    const countEls = document.querySelectorAll('#cart-count');
    countEls.forEach(el => {
      el.textContent = count;
      el.classList.toggle('active', count > 0);
    });
  }

  // ========== ADD TO CART — AJAX ==========
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(productForm);
      const data = {
        id: formData.get('id'),
        quantity: 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(res => res.json())
      .then(() => {
        // Update cart count
        return fetch('/cart.js');
      })
      .then(res => res.json())
      .then(cart => {
        updateCartCount(cart.item_count);

        // Visual feedback
        const btn = productForm.querySelector('.btn-add-to-cart');
        if (btn) {
          const originalText = btn.textContent;
          btn.textContent = '✓ Ajouté au panier';
          btn.style.backgroundColor = '#4a7c59';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.style.backgroundColor = '';
          }, 2000);
        }
      })
      .catch(err => {
        console.error('Erreur ajout panier:', err);
      });
    });
  }

})();
